/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import styled from "styled-components";
import { withTheme } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { updateFilters } from "../../slices/filtersSlice";

const StyledToggleButton = styled(ToggleButton)`
  font-size: ${(props) => props.theme.typography.caption.fontSize} !important;
  color: ${(props) => props.theme.palette.text.primary} !important;
  text-transform: capitalize !important;
`;

const AlertsFilter = ({ theme }) => {
  const alertsOnly = useSelector((state) => {
    return state.filters.alertsOnly;
  });

  const dispatch = useDispatch();
  const history = useHistory();
  const handleChange = (event, value) => {
    dispatch(updateFilters({ filters: { alertsOnly: value }, history }));
  };
  return (
    <ToggleButtonGroup exclusive={true} onChange={handleChange}>
      <StyledToggleButton
        data-testid="all-routes-button"
        theme={theme}
        value={false}
        selected={!alertsOnly}
        size="small"
      >
        All Routes
      </StyledToggleButton>
      <StyledToggleButton
        data-testid="alerts-only-button"
        theme={theme}
        value={true}
        selected={alertsOnly}
        size="small"
      >
        Alerts Only
      </StyledToggleButton>
    </ToggleButtonGroup>
  );
};
export default withTheme(AlertsFilter);
